import { NavLink } from "react-router-dom";
import { routePaths } from "../constants/routes";

const helpfulLinks = [
  { label: "Start Learning Free", to: routePaths.automationTesting },
  { label: "Explore Courses", to: routePaths.enroll },
  { label: "Read Study Notes", to: routePaths.studyNotes },
  { label: "Contact QA Coder", to: routePaths.contact },
];

export default function NotFound() {
  return (
    <section className="not-found-page">
      <div className="not-found-card surface-card">
        <span className="ui-badge">404</span>
        <h1>This page is not available.</h1>
        <p>
          The link may be old, renamed, or typed incorrectly. Pick a useful path below
          and keep moving through your QA learning journey.
        </p>
        <div className="not-found-actions">
          <NavLink className="btn-ui" to={routePaths.home}>
            Go to Home
          </NavLink>
          <NavLink className="btn-ui-secondary" to={routePaths.enroll}>
            Book Free Demo
          </NavLink>
        </div>
        <div className="not-found-links">
          {helpfulLinks.map((link) => (
            <NavLink key={link.to} to={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
}
